import React from 'react';
import { MessageSquareDot, Mail, FolderOpen } from 'lucide-react';

/**
 * Vertical icon rail. Matches the wireframe — icons only, active tab gets
 * an accent bar on the left edge and a tinted background.
 */
const TABS = [
  { id: 'chats', label: 'Chats',  Icon: MessageSquareDot },
  { id: 'email', label: 'Email',  Icon: Mail },
  { id: 'drive', label: 'Drive',  Icon: FolderOpen },
];

export const LeftRail = ({ active, onChange, badges = {} }) => {
  return (
    <nav
      data-testid="ai-agent-left-rail"
      className="flex flex-col items-center gap-1 border-r border-slate-200 bg-slate-50/80 py-3"
      style={{ width: 64 }}
    >
      {TABS.map(({ id, label, Icon }) => {
        const isActive = id === active;
        const badge = badges[id];
        return (
          <button
            key={id}
            data-testid={`ai-rail-tab-${id}`}
            onClick={() => onChange(id)}
            className={
              `group relative flex h-12 w-12 items-center justify-center rounded-xl transition ` +
              (isActive
                ? 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200'
                : 'text-slate-500 hover:bg-white hover:text-slate-900')
            }
            aria-label={label}
            title={label}
          >
            <Icon className="h-5 w-5" />
            {isActive && (
              <span className="absolute left-0 top-1.5 bottom-1.5 w-[3px] rounded-r-full bg-emerald-500" />
            )}
            {badge ? (
              <span className="absolute -right-0.5 -top-0.5 min-w-[18px] rounded-full bg-rose-500 px-1 text-[10px] font-semibold leading-[18px] text-white">
                {badge > 99 ? '99+' : badge}
              </span>
            ) : null}
          </button>
        );
      })}
    </nav>
  );
};
